module.exports = __webpack_public_path__ + "img/B4B.e6f70227.png";